function formatPrice(price) {  
  price = parseFloat(price).toFixed(2);
  return "$"+(new Intl.NumberFormat('es-AR', {})).format(price)
}

function formatPriceNumber(price) {  
  return parseFloat(parseFloat(price).toFixed(2));  
}

function formatDateString(date_string) {
  //Format "yyyy-mm-dd" to "dd/mm/yyyy" (de esta forma no hay problema con UTC)
  const [year, month, day] = date_string.split('-');
  return `${day}/${month}/${year}`;
}

function formatDate(dateString) {
  //Format dd/mm/yyyy to yyyy-mm-dd
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Asegura 2 dígitos
  const day = String(date.getDate()).padStart(2, '0'); // Asegura 2 dígitos
  return `${year}-${month}-${day}`;
}

export const formatUtils = {
  formatPrice,  
  formatPriceNumber,
  formatDateString,
  formatDate
};
